const loadConfig = async () => {
    try {
      const response = await fetch(
        `${process.env.PUBLIC_URL}/webConfig.json`
      );
  
      const config = await response.json();
  
      const appConfigRes = await fetch(
        `${process.env.PUBLIC_URL}/appConfig.json`
      );
      const appConfig = await appConfigRes.json();
  
      console.log("Config loaded", appConfig);
  
      const format = config.format;
      const env = config.env;
      const appConfigFormat = appConfig[format];
      console.log("appConfigFormat", appConfigFormat);
  
      const appConfigFinal = appConfigFormat[env];
      console.log("appConfigFinal", appConfigFinal);
  
      window.appConfig = { ...appConfigFinal, ENV: env };
    } catch (error) {
      console.error("Failed to load config.json", error);
    }
  };
  
  export default loadConfig;
  